import * as Style from './style';
const InputText = ({ expected, setExpected }) => {
    return (
        <Style.Section>
            <Style.TextHeader>
                العلامة المتوقعة
            </Style.TextHeader>
            <Style.InputTExtFa
                width="80%"
                type="number"
                placeholder='أدخل علامتك المتوقعة'
                value={expected}
                onChange={(e) => setExpected(e.target.value)}
            />

        </Style.Section>
    )
}

export default InputText